import "./style.scss";

import { FormHelperText, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { StyledMenuItem, StyledSelect } from "../StyledSelect";
import StyledTextField from "../StyledTextField/StyledTextField";

const InfoBlockProfil = (props: any) => {
    const [t] = useTranslation();
    const { title, data, handleEdit = () => {}, fieldLabels = {}, fieldHelperText = {} } = props;
    const [inputValue, setInputValue] = useState(data);

    const labelsForInput: { [key: string]: string } = {
        name: t("BeneficiarInfo.Name"),
        siret: t("BeneficiarInfo.Siret"),
        intraCommunityVAT: t("Transferees.IntraCommunityTVA"),
        address: t("BeneficiarInfo.StreetNumber"),
        postalCode: t("BeneficiarInfo.ZIPCode"),
        city: t("BeneficiarInfo.City"),
        country: t("BeneficiarInfo.Country"),
        bankAccountName: t("BeneficiarInfo.BankAccountName"),
        iban: t("BeneficiarInfo.IBAN"),
        swift: t("BeneficiarInfo.Swift"),
        transit_number: t("Beneficiary.transit_number"),
        institution_number: t("Beneficiary.institution_number"),
        account_number: t("Beneficiary.account_number"),
        sort_code: t("Beneficiary.sort_code"),
        bacs_sun: t("Company.bacs_sun"),
        phoneNumber: t("CompanySettings.PhoneNumber"),
        apeCode: t("CompanySettings.APECode"),
        activityType: t("CompanySettings.ActivityType"),
        distributorType: t("CompanySettings.DistributorType"),
    };

    useEffect(() => {
        setInputValue(data);
    }, [data]);

    return (
        <div className="info-block">
            <div className="info-block-head">
                <div className="info-block-head-name">{title}</div>
            </div>
            <div className="info-block-list">
                {inputValue &&
                    Object.keys(inputValue).map((item, i) => {
                        if (item === "distributorType") {
                            return (
                                <div className="info-block-list-element" key={i}>
                                    <div className="flex min-h-10 shrink-0 basis-1/4 items-center pr-2">
                                        {labelsForInput[item]}
                                    </div>
                                    {/* <StyledTextField size="small" value={inputValue[item] ? inputValue[item] : ""} sx={{ width: "75%" }} onChange={(ev) => { setInputValue({ ...inputValue, [item]: ev.target.value }); handleEdit({ ...inputValue, [item]: ev.target.value }); }}></StyledTextField> */}
                                    <StyledSelect
                                        value={inputValue[item] ? inputValue[item] : "1"}
                                        onChange={(ev) => {
                                            const updatedInputValue = { ...inputValue, [item]: ev.target.value };
                                            setInputValue(updatedInputValue);
                                            handleEdit(updatedInputValue);
                                        }}
                                        size="small"
                                        sx={{ width: "75%" }}
                                    >
                                        <StyledMenuItem value={1}>
                                            {t("CompanySettings.DistributorTypeSelector.DOE")}
                                        </StyledMenuItem>
                                        <StyledMenuItem value={2}>
                                            {t("CompanySettings.DistributorTypeSelector.DOETHC")}
                                        </StyledMenuItem>
                                        <StyledMenuItem value={3}>
                                            {t("CompanySettings.DistributorTypeSelector.DCA")}
                                        </StyledMenuItem>
                                    </StyledSelect>
                                </div>
                            );
                        }

                        const fieldLabel = fieldLabels[item] ?? labelsForInput[item] ?? item;
                        const fieldHint = fieldHelperText[item];

                        return (
                            <div className="info-block-list-element" key={i}>
                                <div className="flex min-h-10 shrink-0 basis-1/4 items-center pr-2">{fieldLabel}</div>
                                <div className="flex min-w-0 flex-1 flex-col gap-1">
                                    <StyledTextField
                                        size="small"
                                        value={inputValue[item] ? inputValue[item] : ""}
                                        sx={{ width: "100%" }}
                                        onChange={(ev) => {
                                            const updatedInputValue = { ...inputValue, [item]: ev.target.value };
                                            setInputValue(updatedInputValue);
                                            handleEdit(updatedInputValue);
                                        }}
                                    />
                                    {fieldHint && (
                                        <FormHelperText
                                            sx={{
                                                color: "#737373",
                                                fontSize: "11px",
                                                ml: "4px",
                                                mt: 0,
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {fieldHint}
                                        </FormHelperText>
                                    )}
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default InfoBlockProfil;
